import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { loadingDotsAnimation } from "@store/theme/common/mixins/typography";
import { attributesProps } from "@store/theme/common/props/attributes";
import { isAuthenticatedOrRemembered } from "@store/utilities/isAuthenticatedOrRemembered";
import React, { FC } from "react";
import { css } from "styled-components";


interface OwnProps {
    extendedStyles?: StoreProductIsStockedMessageStyles;
    isStocked?: boolean;
    qtyOnHand?: number;
    qtyOrdered?: number;

}

type Props = OwnProps & HasProduct;

export interface StoreProductIsStockedMessageStyles {
    isStockedMessage?: TypographyPresentationProps;
    realTimeText?: TypographyPresentationProps;
}

export const storeProductIsStockedMessageStyles: StoreProductIsStockedMessageStyles = {
    isStockedMessage: attributesProps.message,
    realTimeText: {
        css: css`
            ${loadingDotsAnimation()}
        `,
    },
};

const StoreProductIsStockedMessage: FC<Props> = ({
    extendedStyles,
    isStocked,
    qtyOrdered,
    qtyOnHand,
}) => {
    const [styles] = React.useState(() => mergeToNew(storeProductIsStockedMessageStyles, extendedStyles));

    if (!isAuthenticatedOrRemembered()) {
        return null;
    }

    const isStockedMessage = (message: string) => {
        return (
            <Typography {...styles.isStockedMessage}>
                *{message}
            </Typography>
        );
    };

    let isStockedMessageComponent = <Typography {...styles.realTimeText} />;

    if (isStocked) {
        isStockedMessageComponent = isStockedMessage(translate("Stocking Item"));
    } else if (!isStocked) {
        if (qtyOrdered && qtyOnHand && qtyOnHand > 0 && qtyOrdered <= qtyOnHand) {
            isStockedMessageComponent = isStockedMessage(translate("Non-Stocking item"));
        } else {
            isStockedMessageComponent = isStockedMessage(translate("Non-Stocking item: additional charges may apply"));
        }
    } else {
        return null;
    }

    return (
        <>
            {isStockedMessageComponent}
        </>
    );
};

export default withProduct(StoreProductIsStockedMessage);